// @flow
import {
    ATTEMPT_CREATE_RECIPE,
    ATTEMPT_DELETE_RECIPE,
    ATTEMPT_UPDATE_RECIPE,
    CANCEL_ACTION,
    CANCEL_TEMPLATE,
    EDIT_RECIPE,
    EDIT_SCHEDULE,
    GET_RECIPES,
    HANDLE_NOTIFICATION_CHANGE,
    HANDLE_PROPERTY_CHANGE,
    HIDE_MODAL,
    RECEIVE_RECIPES,
    REQUEST_CONFIRM_DELETE,
    SELECT_CONSUMER,
    SELECT_PRODUCER,
    SELECT_TEMPLATE,
    SHOW_TEMPLATES_LIST,
    TOGGLE_SCHEDULE_STATE,
    UPDATE_DATA,
    UPDATE_RECIPE
} from './constants';
import { getConsumerPropertiesList, templates, updateActionsValue } from '~/core/utils/recipes';

import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';
import { recipeStatus } from '~/core/constants/recipes';

const initialState = fromJS({
    currentRecipe: null,
    hasError: false,
    isFetching: false,
    isFirstLoadingDone: false,
    isLoaded: false,
    modalVisiblePage: null,
    recipes: {},
    templates: []
});

const normaliseRecipes = recipes =>
    recipes
        ? recipes.reduce(
              (recipes, recipe) => ({
                  ...recipes,
                  [recipe.id]: {
                      data: recipe,
                      status: recipeStatus.DISPLAYING
                  }
              }),
              {}
          )
        : {};

const updateCurrentRecipeConsumerProperties = (state, consumerType, recipe) => {
    if (!consumerType) {
        // $FlowFixMe
        const templateName = state.getIn(['currentRecipe', 'name']);
        // for now we use the 1st consumer type in the list of possible consumers, if in the future there
        // will be different properites between types (e.g. difference between lights) then the logic needs
        // to be changed (may happen when we get the advance recipes requirements)
        consumerType = templates[templateName].consumer.types[0];
    }
    const consumerPropertiesList = getConsumerPropertiesList(
        consumerType,
        // $FlowFixMe
        state.getIn(['currentRecipe', 'consumerPropertiesList']),
        recipe
    );
    // $FlowFixMe
    return state.setIn(['currentRecipe', 'consumerPropertiesList'], fromJS(consumerPropertiesList));
};

const selectRecipe = (state, recipe, consumerType, isEditingSchedule) => {
    const isNotification = recipe.get('consumer') === undefined;
    // $FlowFixMe
    state = state.withMutations(s =>
        s
            .set(
                'currentRecipe',
                fromJS({
                    isActive: true,
                    data: recipe,
                    isNotification: isNotification,
                    status: recipeStatus.EDITING
                })
            )
            .set('modalVisiblePage', isEditingSchedule ? 2 : 1)
    );
    if (!isNotification) {
        state = updateCurrentRecipeConsumerProperties(state, consumerType, recipe);
    }
    return state;
};

const actionHandlers = {
    // $FlowFixMe
    [ATTEMPT_CREATE_RECIPE]: handleReduce(state => state.setIn(['currentRecipe', 'status'], recipeStatus.CREATING)),
    [ATTEMPT_DELETE_RECIPE]: handleReduce((state, { payload: recipeId }) =>
        // $FlowFixMe
        state.setIn(['recipes', recipeId, 'status'], recipeStatus.DELETING)
    ),
    [ATTEMPT_UPDATE_RECIPE]: handleReduce((state, { payload: recipe }) => {
        // $FlowFixMe
        if (state.get('currentRecipe')) {
            // $FlowFixMe
            state = state.setIn(['currentRecipe', 'status'], recipeStatus.UPDATING);
        }
        // $FlowFixMe
        return state.setIn(['recipes', recipe.getIn(['data', 'id']), 'status'], recipeStatus.UPDATING);
    }),
    [CANCEL_ACTION]: handleReduce((state, { payload: recipeId }) =>
        // $FlowFixMe
        state.setIn(['recipes', recipeId, 'status'], recipeStatus.DISPLAYING)
    ),
    [CANCEL_TEMPLATE]: handleReduce(state =>
        // $FlowFixMe
        state.withMutations(s => s.set('currentRecipe', null).set('modalVisiblePage', null))
    ),
    [EDIT_RECIPE]: handleReduce((state, { payload: { recipeData, consumerType } }) =>
        selectRecipe(state, recipeData, consumerType)
    ),
    [EDIT_SCHEDULE]: handleReduce((state, { payload: { recipeData, consumerType } }) =>
        selectRecipe(state, recipeData, consumerType, true)
    ),
    // $FlowFixMe
    [GET_RECIPES]: handleReduce(state => state.set('isFetching', true)),
    [HANDLE_NOTIFICATION_CHANGE]: handleReduce((state, { payload: key }) => {
        const path = ['currentRecipe', 'data', 'action', 'value', key];
        // $FlowFixMe
        return state.setIn(path, !state.getIn(path));
    }),
    [HANDLE_PROPERTY_CHANGE]: handleReduce((state, { payload: { index, property, consumerType } }) => {
        // $FlowFixMe
        const propertyIndex = state
            .getIn(['currentRecipe', 'consumerPropertiesList'])
            .findIndex(p => p.get('type') === property);
        // $FlowFixMe
        state = state.setIn(['currentRecipe', 'consumerPropertiesList', propertyIndex, 'selectedIndex'], index);
        state = updateCurrentRecipeConsumerProperties(state, consumerType);
        return state.set('currentRecipe', updateActionsValue(state.get('currentRecipe')));
    }),
    // $FlowFixMe
    [HIDE_MODAL]: handleReduce(state => state.set('modalVisiblePage', null)),
    [RECEIVE_RECIPES]: handleReduce(
        (state, { payload }) =>
            // $FlowFixMe
            state.withMutations(state =>
                state
                    .set('isFetching', false)
                    .set('isLoaded', true)
                    .set('hasError', false)
                    .set('recipes', fromJS(normaliseRecipes(payload.recipes)))
                    .set('templates', fromJS(payload.templates))
            ),
        state =>
            // $FlowFixMe
            state.withMutations(state =>
                state
                    .set('isFetching', false)
                    .set('isLoaded', true)
                    .set('hasError', true)
                    .set('recipes', fromJS({}))
                    .set('templates', fromJS([]))
            )
    ),
    [REQUEST_CONFIRM_DELETE]: handleReduce((state, { payload: recipeId }) =>
        // $FlowFixMe
        state.setIn(['recipes', recipeId, 'status'], recipeStatus.CONFIRMING)
    ),
    [SELECT_CONSUMER]: handleReduce((state, { payload: consumerId }) => {
        state = updateCurrentRecipeConsumerProperties(state);
        state = state.set('currentRecipe', updateActionsValue(state.get('currentRecipe')));
        return state.setIn(['currentRecipe', 'data', 'consumer'], consumerId);
    }),
    [SELECT_PRODUCER]: handleReduce((state, { payload: { producerId, specificConsumerId } }) => {
        // if it has a consumer then the id has to be reset
        // $FlowFixMe
        if (state.getIn(['currentRecipe', 'isNotification']) === false) {
            // $FlowFixMe
            const template = state.get('templates').find(t => t.get('name') === state.getIn(['currentRecipe', 'name']));
            const consumers = template
                .get('producers')
                .find(p => p.get('id') === producerId)
                .get('consumers');
            let consumerId = -1;
            if (specificConsumerId) {
                // this is for when the recipes are displayed in a consumer product page
                consumerId = specificConsumerId;
            } else if (consumers.size === 1) {
                // if there is one only one possible consumer then put it as selected by default
                consumerId = consumers.get(0);
            }
            // if there is a consumerId then get its properties
            if (consumerId !== -1) {
                state = updateCurrentRecipeConsumerProperties(state);
                state = state.set('currentRecipe', updateActionsValue(state.get('currentRecipe')));
            }
            // $FlowFixMe
            state = state.setIn(['currentRecipe', 'data', 'consumer'], consumerId);
        }
        // $FlowFixMe
        return state.setIn(['currentRecipe', 'data', 'producer'], producerId);
    }),
    [SELECT_TEMPLATE]: handleReduce((state, { payload: { producerId, templateName, specificConsumerId } }) => {
        const definition = templates[templateName];
        // $FlowFixMe
        const template = state.get('templates').find(t => t.get('name') === templateName);
        const isNotification = definition.isNotification === true;
        let producer = -1;
        if (producerId) {
            producer = producerId;
        } else if (template.get('producers').size === 1) {
            // if there is one only one possible producer then put it as selected by default
            producer = template.getIn(['producers', 0, 'id']);
        }

        // $FlowFixMe
        state = state.withMutations(s =>
            s
                .set(
                    'currentRecipe',
                    fromJS({
                        data: {
                            action: template.get('action'),
                            producer,
                            trigger: template.get('trigger')
                        },
                        isActive: definition.producer.active,
                        isNotification,
                        name: templateName,
                        status: recipeStatus.DEFINING
                    })
                )
                .set('modalVisiblePage', 1)
        );

        if (!isNotification) {
            let consumerId = -1;
            // if there is only one producer check if there is also only one consumer for this producer
            if (producer !== -1) {
                if (specificConsumerId) {
                    // this is for when the recipes are displayed in a consumer product page
                    consumerId = specificConsumerId;
                } else {
                    const consumers = template
                        .get('producers')
                        .find(p => p.get('id') === producer)
                        .get('consumers');
                    // if there is one only one possible consumer then put it as selected by default
                    if (consumers.size === 1) {
                        consumerId = consumers.get(0);
                    }
                }
            }
            // if there is a consumerId then get its properties
            if (consumerId !== -1) {
                state = updateCurrentRecipeConsumerProperties(state);
                state = state.set('currentRecipe', updateActionsValue(state.get('currentRecipe')));
            }
            state = state.setIn(['currentRecipe', 'data', 'consumer'], consumerId);
        }

        return state;
    }),
    // $FlowFixMe
    [SHOW_TEMPLATES_LIST]: handleReduce(state => state.set('modalVisiblePage', 0)),
    [TOGGLE_SCHEDULE_STATE]: handleReduce(state => {
        const path = ['currentRecipe', 'data', 'scheduled'];
        // $FlowFixMe
        return state.setIn(path, !state.getIn(path));
    }),
    [UPDATE_DATA]: handleReduce((state, { payload: { recipes, templates } }) => {
        // $FlowFixMe
        return state.withMutations(state =>
            state
                .set('recipes', fromJS(normaliseRecipes(recipes)))
                .set('templates', fromJS(templates))
                .set('currentRecipe', null)
                .set('modalVisiblePage', null)
        );
    }),
    [UPDATE_RECIPE]: handleReduce((state, { payload: recipeData }) =>
        // $FlowFixMe
        state.withMutations(state =>
            state
                .setIn(['recipes', recipeData.id, 'status'], recipeStatus.DISPLAYING)
                .setIn(['recipes', recipeData.id, 'data'], fromJS(recipeData))
                .set('modalVisiblePage', null)
        )
    )
};

export default handleActions(actionHandlers, initialState);



// WEBPACK FOOTER //
// ./src/core/state/recipes/index.js